module.exports = __webpack_public_path__ + "media/images/icon_congratulations_95-20-f2382be1a1117159094430caaae1e641.png";